import { useSelector } from 'react-redux';

import { UserProfileState } from '../redux/slice/user-profile';
import { RootState } from '../redux/store';

export const useUserProfileContext = (): UserProfileState => {
  const state: UserProfileState = useSelector((state: RootState) => state.userProfile);
  return state;
};
